import axiosInstance from "apiConfig";



// export const sendContactMessage = async (data) => {
//     try {
//         const response = await fetch(`${API_BASE_URL}/contact`, {
//             method: "POST",
//             headers: {
//                 "Content-Type": "application/json",
//             },
//             body: JSON.stringify(data),
//         });

//         const result = await response.json();
//         return result;
//     } catch (error) {
//         console.error("Error sending contact message:", error);
//         return { success: false, error: "Something went wrong. Try again later." };
//     }
// };


export const sendContactMessage = async (data) => {
  try {
    const response = await axiosInstance.post("/mail/contact", data); // Send flat object
    return response.data;
  } catch (error) {
    console.error("Error adding new lead:", error);
    throw error;
  }
};

export const bookDemo = async (data) => {
  try {
    const response = await axiosInstance.post("/mail/demo", data); // Send flat object
    return response.data;
  } catch (error) {
    console.error("Error booking demo:", error);
    throw error;
  }
}